"use strict";

exports.__esModule = true;
exports.INIT_ANALYTICS = exports.GET_DATA_SUCCESS = exports.GET_DATA_REQUEST = exports.GET_DATA_FAILURE = void 0;
const INIT_ANALYTICS = exports.INIT_ANALYTICS = 'INIT_ANALYTICS';
const GET_DATA_REQUEST = exports.GET_DATA_REQUEST = 'GET_DATA_REQUEST';
const GET_DATA_SUCCESS = exports.GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
const GET_DATA_FAILURE = exports.GET_DATA_FAILURE = 'GET_DATA_FAILURE';